import type { CompareDesignTokens } from '@primeuix/themes/types/compare';

export default {
    root: {
        borderRadius: '{content.border.radius}',
    },
    handle: {
        background: '{content.background}',
        size: '1px',
    },
    indicator: {
        size: '1.5rem',
        background: '{content.background}',
        borderRadius: '{content.border.radius}',
        focusRing: {
            width: '2px',
            style: 'solid',
            color: '{content.background}',
            offset: '2px',
        },
        icon: {
            color: '{text.muted.color}',
            size: '{icon.size}',
        },
    },
} satisfies CompareDesignTokens;
